import React from "react";
import ContactForm from "../ContactFrom";
import sImg from "../../images/resource/contact.png";
import instaIcon from "../../images/icons/insta.png";
import fbIcon from "../../images/icons/fb.png";
import linkedinIcon from "../../images/icons/linkedin.png";
import youtubeIcon from "../../images/icons/youtube.png";

const Contactpage3 = () => {
  return (
    <div>
      <section className="contact-page-section-two">
        <div className="auto-container">
          <div className="row clearfix">
            {/* <div className="map-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <div className="map-outer">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24090.09275130237!2d91.84372506856128!3d26.163682880896427!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375af730583fe8c7%3A0x8c81096ac2a7ba9b!2zUm9oaXTigJlz!5e0!3m2!1sen!2sin!4v1759569636684!5m2!1sen!2sin"
                    allowFullScreen=""
                  ></iframe>
                </div>
              </div>
            </div> */}
            <div className="info-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <ul className="info">
                  <li>
                    <span>Email</span>hello@thelushminds.in
                  </li>
                  <li>
                    <span>Phone number</span>+91 98642 54608
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <ul className="info">
                  <li>
                      <span>Social Media</span>
                      <a
                        href="https://www.instagram.com/the.lushminds?igsh=b3Qzc3FpaGk0ZHA3"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          marginLeft: "2px",
                          display: "flex",
                          alignItems: "center",
                          textDecoration: "none",
                          color: "#E4405F",
                          fontSize: "16px",
                        }}
                      >
                        <img
                          src={instaIcon}
                          alt="Instagram"
                          style={{
                            width: "40px",
                            height: "40px",
                            marginRight: "4px",
                          }}
                        />
                        @the.lushminds
                      </a>
                      <a
                        href="https://www.facebook.com/profile.php?id=61577134713442&rdid=xWcN2RVaLKiYTgda&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1A2ucU11FV%2F#"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          marginLeft: "2px",
                          display: "flex",
                          alignItems: "center",
                          textDecoration: "none",
                          color: "#4267B2",
                          fontSize: "16px",
                        }}
                      >
                        <img
                          src={fbIcon}
                          alt="Facebook"
                          style={{
                            width: "40px",
                            height: "40px",
                            marginRight: "4px",
                          }}
                        />
                        @thelushminds
                      </a>
                      <a
                        href="https://www.linkedin.com/company/thelushminds/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          marginLeft: "2px",
                          display: "flex",
                          alignItems: "center",
                          textDecoration: "none",
                          color: "#0077B5",
                          fontSize: "16px",
                        }}
                      >
                        <img
                          src={linkedinIcon}
                          alt="LinkedIn"
                          style={{
                            width: "40px",
                            height: "40px",
                            marginRight: "4px",
                          }}
                        />
                        @thelushminds
                      </a>
                      <a
                        href="https://www.youtube.com/@the.lushminds"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          marginLeft: "2px",
                          display: "flex",
                          alignItems: "center",
                          textDecoration: "none",
                          color: "#FF0000",
                          fontSize: "16px",
                        }}
                      >
                        <img
                          src={youtubeIcon}
                          alt="YouTube"
                          style={{
                            width: "40px",
                            height: "40px",
                            marginRight: "4px",
                          }}
                        />
                        @thelushminds
                      </a>
                    </li>
                  {/* <li>
                    <span>Send us mail</span>To Know More, Contact Us.
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="contact-form-section">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="form-column col-lg-7 col-md-12 col-sm-12">
              <div className="inner-column">
                <h3>Send us a message</h3>

                <div className="default-form contact-form">
                  <ContactForm />
                </div>
              </div>
            </div>
            <div className="image-column col-lg-5 col-md-12 col-sm-12">
              <div className="inner-column">
                <div
                  className="image wow fadeInRight"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <img src={sImg} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Contactpage3;
